<!-- Carousel -->
<div id="obiettivicarousel" class="carousel slide" data-bs-ride="carousel">
    <!-- The slideshow/carousel -->
    <div class="carousel-inner ">
        <div class="carousel-item active" data-bs-interval="10000">
            <img src="/assets/1.png" alt="1" class="d-block w-100">
        </div>
        <div class="carousel-item " data-bs-interval="10000">
            <img src="/assets/2.png" alt="2" class="d-block w-100">
        </div>
        <div class="carousel-item" data-bs-interval="10000">
            <img src="/assets/3.png" alt="3" class="d-block w-100">
        </div>
        <div class="carousel-item" data-bs-interval="10000">
            <img src="/assets/4.png" alt="4" class="d-block w-100">
        </div>
    </div>
    <!-- Left and right controls/icons -->
    <a class="carousel-control-prev" href="#obiettivicarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#obiettivicarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>